"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterEmptyDateRange = void 0;
exports.filterEmptyDateRange = function (data) {
    return data.filter(function (item) { return item.startDate !== undefined && item.endDate !== undefined; });
};
exports.default = exports.filterEmptyDateRange;
